import { render } from "./RecipesForm.vue?vue&type=template&id=2a5a6fff"
import script from "./RecipesForm.vue?vue&type=script&lang=js"
export * from "./RecipesForm.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\stick\\projects\\recipe-project\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__